
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Navigation from "./components/Navigation";
import DisclaimerBanner from "./components/DisclaimerBanner";
import Footer from "./components/Footer";
import Index from "./pages/Index";
import About from "./pages/About";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Contact from "./pages/Contact";
import Solutions from "./pages/Solutions";
import DeepseekLogin from "./pages/DeepseekLogin";
import DeepseekStock from "./pages/DeepseekStock";
import DeepseekR1 from "./pages/DeepseekR1";
import DeepLearningAI from "./pages/DeepLearningAI";
import VibeCoding from "./pages/VibeCoding";
import ChromeExtensionUninstall from "./pages/ChromeExtensionUninstall";
import ChromeExtensionUpdate from "./pages/ChromeExtensionUpdate";
import AIChat from "./pages/AIChat";
import WhatIsDeepseekAI from "./pages/WhatIsDeepseekAI";
import Deepseek from "./pages/Deepseek";
import DeepseekR2Challenges from "./pages/BlogPosts/DeepseekR2Challenges";
import WhatIsDeepLearningAI from "./pages/BlogPosts/WhatIsDeepLearningAI";
import WhatIsDeepSeek from "./pages/BlogPosts/WhatIsDeepSeek";
import DeepseekV31 from "./pages/BlogPosts/DeepseekV31";
import Llama4VsDeepseek from "./pages/BlogPosts/Llama4VsDeepseek";
import DeepseekR2 from "./pages/BlogPosts/DeepseekR2";
import DeepseekAI from "./pages/DeepseekAI";
import PrivacyPolicy from "./pages/PrivacyPolicy";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <DisclaimerBanner />
        <Navigation />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/about" element={<About />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/blog/vibe-coding" element={<VibeCoding />} />
          <Route path="/blog/ai-chat" element={<AIChat />} />
          <Route path="/blog/deepseek-r2-challenges" element={<DeepseekR2Challenges />} />
          <Route path="/blog/what-is-deep-learning-ai" element={<WhatIsDeepLearningAI />} />
          <Route path="/blog/what-is-deep-seek" element={<WhatIsDeepSeek />} />
          <Route path="/blog/deepseek-v31" element={<DeepseekV31 />} />
          <Route path="/blog/what-is-deepseek-ai" element={<WhatIsDeepseekAI />} />
          <Route path="/blog/llama-4-vs-deepseek" element={<Llama4VsDeepseek />} />
          <Route path="/blog/deepseek-r2-ai-model-launch-2025" element={<DeepseekR2 />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/deepseek-login" element={<DeepseekLogin />} />
          <Route path="/deepseek-stock" element={<DeepseekStock />} />
          <Route path="/deepseek-r1" element={<DeepseekR1 />} />
          <Route path="/deep-learning-ai" element={<DeepLearningAI />} />
          <Route path="/what-is-deepseek-ai" element={<WhatIsDeepseekAI />} />
          <Route path="/deepseek" element={<Deepseek />} />
          <Route path="/deepseek-ai" element={<DeepseekAI />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/chrome-extension-uninstall" element={<ChromeExtensionUninstall />} />
          <Route path="/chrome-extension-update" element={<ChromeExtensionUpdate />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
